export const get_screens_info = () => {
    var myHeaders = new Headers();
    myHeaders.append("X-Access-Token", "2312");

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };

    return fetch("http://192.168.1.140:8001/textura/machines?page=0", requestOptions)
        .then(response => response.json())
        .then(result => {
            console.log(result)
            return result.result
        })
        .catch(error => console.log('error', error));
}